export function hasKey(value: object, key: string): value is { [key: string]: unknown } {
    return Object.prototype.hasOwnProperty.call(value, key);
}
